import { computed, inject, Service, signal } from '@angular/core';
import {
  ICodetableItem,
  IKidsPotentielle,
  IKidsTermin,
  isDruckAbsagePassiert,
  isDruckZusagePassiert,
  isStatusAbgesagt,
  isStatusFixZugesagt
} from '@mng/mgs-lib';
import { MgsWebApi } from '../../../mgs-webapi.service';
import { KidsTermineStore } from '../kids-termine.store';
import { KidsPotentielleStore } from '../../kids-potentielle/kids-potentielle.store';
import { KidsDruckanforderungService } from '../../kids-druckanforderung.service';
import { DienstleistungService } from '../../../dienstleistung/dienstleistung.service';

@Service()
export class KidsTerminService {
  readonly mgsWebApi = inject(MgsWebApi);
  readonly dienstleistungService = inject(DienstleistungService);

  readonly kidsTermineStore = inject(KidsTermineStore);
  readonly kidsPotentielleStore = inject(KidsPotentielleStore);

  readonly kidsDruckanforderungService = inject(KidsDruckanforderungService);

  readonly kidsTermin = signal<IKidsTermin>(undefined);

  readonly selectedKidId = signal<number | undefined>(undefined);

  kids = this.kidsPotentielleStore.entities;

  readonly druckZusageMoeglich = computed(() =>
    this.kids().some((kid) => !isDruckZusagePassiert(kid) && isStatusFixZugesagt(kid))
  );
  readonly druckAbsageMoeglich = computed(() =>
    this.kids().some((kid) => !isDruckAbsagePassiert(kid) && isStatusAbgesagt(kid))
  );

  async load(terminId: number): Promise<void> {
    this.kidsTermin.set(this.kidsTermineStore.entities().find((termin) => termin.id === terminId));
    await this.kidsPotentielleStore.updateSuche({ kidsTerminId: terminId });
  }

  async reload() {
    await this.kidsPotentielleStore.load();
  }

  async kidsStatusAendern(kid: IKidsPotentielle, terminStatus: ICodetableItem) {
    const kidWithStatusUpdate = { ...kid, terminStatus };
    await this.kidsPotentielleStore.update(kidWithStatusUpdate);
  }

  resetSelectedKid() {
    this.selectedKidId.set(undefined);
  }

  async druckAnforderungTermin(zusage: boolean) {
    await this.kidsDruckanforderungService.druckAnforderungTermin(zusage, this.kidsTermin().id);
    await this.reload();
  }
}
